/*
 * Цвет кнопок окна на Windows. Система рисует их поверх страницы в правом верхнем углу, а цвет подложки
 * мы задаём сами (setTitleBarOverlay). Раньше это был один токен (--bg-secondary): на «Друзьях», в канале
 * без списка участников и в настройках под кнопками другой фон, и они выделялись прямоугольником.
 * Теперь берём то, что действительно лежит под кнопками: фоны всех слоёв в этой точке, снизу вверх,
 * с прозрачностью — затемнение под открытым окном тоже учитывается.
 */

type Rgba = [number, number, number, number]

/** Цвет из getComputedStyle: rgb(), rgba() или color(srgb …); прозрачное и непонятное — null. */
export function parseCssColor(value: string): Rgba | null {
  const rgb = /^rgba?\(\s*([\d.]+)[,\s]+([\d.]+)[,\s]+([\d.]+)\s*(?:[,/]\s*([\d.]+)(%?))?\s*\)$/.exec(value.trim())
  if (rgb) {
    const alpha = rgb[4] === undefined ? 1 : Number(rgb[4]) / (rgb[5] ? 100 : 1)
    return [Number(rgb[1]), Number(rgb[2]), Number(rgb[3]), alpha]
  }
  const srgb = /^color\(srgb\s+([\d.]+)\s+([\d.]+)\s+([\d.]+)\s*(?:\/\s*([\d.]+)(%?))?\s*\)$/.exec(value.trim())
  if (srgb) {
    const alpha = srgb[4] === undefined ? 1 : Number(srgb[4]) / (srgb[5] ? 100 : 1)
    return [Number(srgb[1]) * 255, Number(srgb[2]) * 255, Number(srgb[3]) * 255, alpha]
  }
  return null
}

/** Слои снизу вверх → итоговый цвет в #rrggbb; ни одного непрозрачного слоя — null. */
export function compositeColors(bottomToTop: string[]): string | null {
  let out: [number, number, number] | null = null
  for (const value of bottomToTop) {
    const c = parseCssColor(value)
    if (!c || c[3] <= 0) continue
    const [r, g, b, a] = c
    out = out ? [r * a + out[0] * (1 - a), g * a + out[1] * (1 - a), b * a + out[2] * (1 - a)] : [r, g, b]
  }
  return out ? '#' + out.map((v) => Math.round(Math.min(255, Math.max(0, v))).toString(16).padStart(2, '0')).join('') : null
}

/** Что сейчас под кнопками окна: середина их полосы, 70 px от правого края. */
export function colorUnderWindowControls(): string | null {
  if (typeof document === 'undefined') return null
  const stack = document.elementsFromPoint(window.innerWidth - 70, 24)
  return compositeColors(stack.reverse().map((el) => getComputedStyle(el).backgroundColor))
}
